module.exports = __webpack_public_path__ + "static/media/attachment-from-drive.d9ca2da1.svg";